export enum QueryKeys {
  USER_DATA = 'userData',
}
